export interface AuthState {
  user: {
    role: string;
    uid: string;
    displayName: string;
    email: string;
  };
  userModules: string[];   
}

const initialState: AuthState = {
  user: {
    role: "",
    uid: "",
    displayName: "",
    email: "",
  },
  userModules: [],   
};

const Auth = (state = initialState, action: any): AuthState => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        user: action.payload.user,      
        userModules: action.payload.modules || [],  
      };
    case "LOGOUT":
      return initialState;
    default:
      return state;
  }
};

export default Auth;
